"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadarChart = void 0;
var React = __importStar(require("react"));
var common_1 = require("../common");
var recharts_1 = require("recharts");
var utils_1 = require("../utils");
var theme_1 = require("@epic-visualizations/theme");
var RadarChart = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.dataColors, dataColors = _c === void 0 ? {} : _c, _d = _a.animate, animate = _d === void 0 ? false : _d, _e = _a.responsive, responsive = _e === void 0 ? true : _e, width = _a.width, height = _a.height, minWidth = _a.minWidth, minHeight = _a.minHeight, radarProps = _a.radarProps, locales = _a.locales, _f = _a.hideTooltip, hideTooltip = _f === void 0 ? false : _f, tooltipFormatterOptions = _a.tooltipFormatterOptions, _g = _a.tooltipFormatter, tooltipFormatter = _g === void 0 ? (0, utils_1.numberFormatter)(locales, tooltipFormatterOptions) : _g, tooltipLabelFormatterOptions = _a.tooltipLabelFormatterOptions, _h = _a.tooltipLabelFormatter, tooltipLabelFormatter = _h === void 0 ? (0, utils_1.dateFormatter)(locales, tooltipLabelFormatterOptions) : _h, tooltipMinWidth = _a.tooltipMinWidth, showLegend = _a.showLegend, _j = _a.polarAngleAxis, polarAngleAxis = _j === void 0 ? "time" : _j, polarAngleTickFormatterOptions = _a.polarAngleTickFormatterOptions, _k = _a.polarAngleTickFormatter, polarAngleTickFormatter = _k === void 0 ? polarAngleTickFormatterOptions
        ? (0, utils_1.dateFormatter)(locales, polarAngleTickFormatterOptions)
        : (0, utils_1.compactDateFormatter)(locales) : _k, polarAngleAxisProps = _a.polarAngleAxisProps, polarRadiusTickFormatterOptions = _a.polarRadiusTickFormatterOptions, _l = _a.polarRadiusTickFormatter, polarRadiusTickFormatter = _l === void 0 ? polarRadiusTickFormatterOptions
        ? (0, utils_1.numberFormatter)(locales, polarRadiusTickFormatterOptions)
        : (0, utils_1.compactNumberFormatter)(locales) : _l, polarRadiusAxisProps = _a.polarRadiusAxisProps, polarGridProps = _a.polarGridProps, tooltipContent = _a.tooltipContent, tooltipProps = _a.tooltipProps, responsiveContainerProps = _a.responsiveContainerProps, _m = _a.LegendComponent, LegendComponent = _m === void 0 ? common_1.Legend : _m, children = _a.children, restProps = __rest(_a, ["data", "dataColors", "animate", "responsive", "width", "height", "minWidth", "minHeight", "radarProps", "locales", "hideTooltip", "tooltipFormatterOptions", "tooltipFormatter", "tooltipLabelFormatterOptions", "tooltipLabelFormatter", "tooltipMinWidth", "showLegend", "polarAngleAxis", "polarAngleTickFormatterOptions", "polarAngleTickFormatter", "polarAngleAxisProps", "polarRadiusTickFormatterOptions", "polarRadiusTickFormatter", "polarRadiusAxisProps", "polarGridProps", "tooltipContent", "tooltipProps", "responsiveContainerProps", "LegendComponent", "children"]);
    var theme = (0, theme_1.useVisualizationsTheme)();
    var getComparisonColor = (0, theme_1.useComparisonColor)();
    var radarPropsMap = radarProps === null || radarProps === void 0 ? void 0 : radarProps.reduce(function (radars, radar) {
        radars[radar.dataKey] = radar;
        return radars;
    }, {});
    var dataKeys = data.length > 0
        ? Object.keys(data[0]).filter(function (k) { return k !== polarAngleAxis; })
        : [];
    var radars = dataKeys.map(function (dataKey, index) {
        var _a, _b;
        var dataColor = getComparisonColor((_a = dataColors[dataKey]) !== null && _a !== void 0 ? _a : index);
        var props = radarPropsMap === null || radarPropsMap === void 0 ? void 0 : radarPropsMap[dataKey];
        return (React.createElement(recharts_1.Radar, __assign({ key: dataKey, isAnimationActive: Boolean(animate), dataKey: dataKey, strokeWidth: 2, stroke: dataColor, fill: dataColor, fillOpacity: 0.5, legendType: "circle", dot: false, activeDot: {
                r: 4.5,
                stroke: dataColor,
                fill: theme.defaultBackground,
                strokeWidth: 2,
            }, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: (_b = radarProps === null || radarProps === void 0 ? void 0 : radarProps[index]) === null || _b === void 0 ? void 0 : _b.ref }, props)));
    });
    var isLegendVisible = (showLegend === undefined && radars.length > 1) || showLegend;
    var formattedData = data.map(function (val) {
        var _a;
        return (__assign(__assign({}, val), { time: (_a = val.time) === null || _a === void 0 ? void 0 : _a.toString() }));
    });
    var chart = (React.createElement(recharts_1.RadarChart, __assign({ data: formattedData, width: !responsive ? width : undefined, height: !responsive ? height : undefined }, restProps),
        React.createElement(recharts_1.PolarAngleAxis, __assign({ axisLineType: "circle", stroke: theme.axisColor, tickFormatter: polarAngleTickFormatter, tickLine: false, tick: {
                fill: theme.axisLabel,
                fontSize: theme.axisFontSize,
            }, dataKey: polarAngleAxis, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: polarAngleAxisProps === null || polarAngleAxisProps === void 0 ? void 0 : polarAngleAxisProps.ref }, polarAngleAxisProps)),
        React.createElement(recharts_1.PolarRadiusAxis, __assign({ axisLine: false, stroke: theme.axisColor, tickFormatter: polarRadiusTickFormatter, tick: {
                fill: theme.axisLabel,
                fontSize: theme.axisFontSize,
            }, type: "number", 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: polarRadiusAxisProps === null || polarRadiusAxisProps === void 0 ? void 0 : polarRadiusAxisProps.ref }, polarRadiusAxisProps)),
        React.createElement(recharts_1.PolarGrid, __assign({ stroke: theme.axisColor, gridType: "circle", 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: polarGridProps === null || polarGridProps === void 0 ? void 0 : polarGridProps.ref }, polarGridProps)),
        !hideTooltip && data.length > 0 && (React.createElement(recharts_1.Tooltip, __assign({ content: React.createElement(common_1.CustomTooltip, { formatter: tooltipFormatter, labelFormatter: tooltipLabelFormatter, minWidth: tooltipMinWidth, tooltipContent: tooltipContent }), cursor: false, wrapperStyle: {
                zIndex: theme.zIndexTooltip,
            }, separator: ": " }, tooltipProps))),
        radars,
        children));
    return (React.createElement(React.Fragment, null,
        responsive ? (React.createElement(recharts_1.ResponsiveContainer, __assign({ width: width, height: height, minWidth: minWidth, minHeight: minHeight }, responsiveContainerProps), chart)) : (chart),
        isLegendVisible && (React.createElement(LegendComponent, { dataKeys: dataKeys, dataColors: dataColors }))));
};
exports.RadarChart = RadarChart;
//# sourceMappingURL=RadarChart.js.map